import { get } from "../api_helper"
import { getApiConfig } from "../authHelper"

// GET /accounting-partner-report?startDate&endDate&search
//   -> { summary, partners: [{ partnerId, name, mobileNo, firmName, totalLeads, demoCompleted, converted, notInterested, totalSelling, totalCollected, conversionRate }] }
export const getAccountingPartnerReport = params => get("/accounting-partner-report", { ...getApiConfig(), params })

// GET /accounting-partner-report/:partnerId/leads?page&limit&search
//   -> { partner, count, totalBaseAmount, leads } — the same lead rows the partner sees in the CA panel
export const getAccountingPartnerLeads = (partnerId, params) =>
  get(`/accounting-partner-report/${partnerId}/leads`, { ...getApiConfig(), params })
